import { useEffect, useState } from "react";
import api from "../api";

export default function PublicReview() {
  const p = new URLSearchParams(window.location.search);
  const id = p.get("appt") || p.get("id") || "";
  const pIdx = p.get("p");
  const [card, setCard] = useState(null);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!id) { setErr("Link non valido."); return; }
    api.get(`/appointments/${id}/card${pIdx !== null ? `?p=${pIdx}` : ""}`).then((r) => setCard(r.data)).catch(() => setErr("Appuntamento non trovato."));
  }, [id, pIdx]);

  const submit = async () => {
    if (!rating) { alert("Seleziona una valutazione"); return; }
    setBusy(true);
    try {
      const r = await api.post(`/appointments/${id}/review`, { rating, feedback: feedback || null, p: pIdx !== null ? Number(pIdx) : null });
      setResult(r.data);
      if (rating >= 5 && r.data.google_review_link) {
        window.open(r.data.google_review_link, "_blank", "noopener");
      }
    } catch (e) { alert(e.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };

  if (err) return <div className="public-wrap"><div className="public-card"><p className="muted">{err}</p></div></div>;
  if (!card) return <div className="public-wrap"><p className="muted">Caricamento…</p></div>;

  if (card.review_done && !result) return (
    <div className="public-wrap"><div className="public-card" style={{ textAlign: "center" }}>
      <h1>Grazie!</h1><p className="muted">Hai già lasciato la tua valutazione.</p>
    </div></div>
  );

  if (result) return (
    <div className="public-wrap" data-testid="review-result"><div className="public-card" style={{ textAlign: "center" }}>
      {result.rating >= 5 ? (
        <>
          <h1 style={{ color: "#22c55e" }}>Grazie di cuore! ⭐️⭐️⭐️⭐️⭐️</h1>
          {result.google_review_link
            ? <><p>Ci aiuteresti lasciando la stessa recensione anche su Google?</p>
                <a className="btn primary" href={result.google_review_link} target="_blank" rel="noopener noreferrer" data-testid="google-review-link">Lascia una recensione su Google</a></>
            : <p>Apprezziamo molto la tua fiducia.</p>}
        </>
      ) : (
        <><h1>Grazie per il tuo riscontro</h1><p className="muted">Faremo tesoro dei tuoi suggerimenti per migliorare.</p></>
      )}
    </div></div>
  );

  return (
    <div className="public-wrap">
      <div className="public-card" style={{ textAlign: "center" }}>
        <h1 className="page-title">Com'è andato l'incontro?</h1>
        <p className="page-sub">Studio Dott.ssa Silvia Casali — {String(card.date || "").split("-").reverse().join("/")} {card.time}</p>
        <div data-testid="star-rating" style={{ fontSize: 44, margin: "16px 0", cursor: "pointer", userSelect: "none" }}>
          {[1, 2, 3, 4, 5].map((n) => (
            <span key={n} onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} onClick={() => setRating(n)}
              data-testid={`star-${n}`} style={{ color: (hover || rating) >= n ? "#f59e0b" : "#3a4a5a", padding: "0 4px" }}>★</span>
          ))}
        </div>
        {rating > 0 && rating < 5 && (
          <div className="field" style={{ textAlign: "left" }}><label>Cosa possiamo migliorare? (facoltativo)</label>
            <textarea rows={4} value={feedback} onChange={(e) => setFeedback(e.target.value)} data-testid="review-feedback" />
          </div>
        )}
        <button className="btn primary" onClick={submit} disabled={busy || !rating} data-testid="review-submit">{busy ? "Invio…" : "Invia valutazione"}</button>
      </div>
    </div>
  );
}
